import React, {useEffect, useMemo, useState} from 'react';
import {Button, Card, Col, Form, InputGroup, Row} from "react-bootstrap";
import {XLg} from "react-bootstrap-icons";
import {useStore} from "../../../../stores/StoreHelpers";
import AsyncSelect from "react-select/async";
import {useRequestObject} from "../../../../hooks/useRequestObject";
import {ArticlesStore} from "../../../../stores/PortfolioProject/ArticlesStore";
import useAPI from "../../../../hooks/useAPI";
import useToast from "../../../../hooks/useToast";
import {ArticlesRequests} from "../../../../requests/PortfolioRequests/articlesRequests";
import style from './style.module.less'
import {observer} from "mobx-react";
import ArticleCard from "./ArticleCard";
import {toJS} from "mobx";
import {useHistory, useParams} from "react-router-dom";
import FindWithSelectComponent from "../../../FindWithSelect/FindWithSelectComponent";
import InnerPageComponent from "../../../../pages/project/PortfolioProject/InnerPageComponent";
import {years} from "../../../../helpers";
import {getActionsModel} from "../../../../services/roles/factdataRoleStatus";
import StatusBadge from "../../../common/StatusBadge";
import {
    isCommandManagmentOrProjOffice, isStrategyTeam,
} from "../../../../services/rolesSvc";
import useUserContext from "../../../../hooks/useUserContext";
import ConfirmModal from "../../../common/ConfirmModal";
import HintCard from "../../../common/HintCard/HintCard";
import ButtonsCardContainer from "../../../ButtonsCardConatianer/ButtonsCardContainer";

const ArticleForm = observer(() => {

    const store = useStore()
    const api = useAPI()
    const userCtx = useUserContext();
    const {projId,stratId,portfolioId,articleId} = useParams()
    const [confirmModalOpen,setConfirmModalOpen] = useState(false)
    const addToast = useToast()
    const history = useHistory()
    const requests = useRequestObject({classType:ArticlesRequests,api,addToast,store,projId,portfolioId})

    const can = useMemo(() => getActionsModel(store.articles.resultObject?.status, userCtx, stratId, portfolioId, projId ?? store.articles.resultObject?.projId), [store.articles.resultObject, userCtx]);
    const isArticleNew = useMemo(()=>{
        return isNaN(articleId)
    },[articleId])

    useEffect(()=>{
        if(!isArticleNew && !store.articles.allArticles){
            requests.getArticleById(articleId)
                .then((element)=>{
                    store.articles.setResultObject(element.article)
                })
        }
    },[])

    return (isCommandManagmentOrProjOffice(userCtx,stratId,projId,portfolioId) &&
        <InnerPageComponent backAction={()=>{
            new Promise(resolve => {
                resolve(history.goBack())
            })
                .then(()=> store.articles.clearStoreOnCardExit())
        }} projId={projId} header={'Статьи'}>
            { isArticleNew && can.Edit &&
                        <FindWithSelectComponent
                            noOptionsMessage={() => {
                                // store.articles.noOptionSearch = true
                                return 'Ничего не найдено'
                            }}
                            loadingMessage={() => 'Поиск...'}
                            placeholder="DOI, ID WOS или ID Scopus"
                            value={store.articles.searchElement ? {value:store.articles.searchElement.id,label:store.articles.searchElement.label} : store.articles.searchInput ? {value:'',label:store.articles.searchInput} : '' }

                            defaultOptions={[]}
                            defaultValue={[]}
                            loadOptions={(inputValue,callback) => {
                                store.articles.setSearchInput(inputValue)
                                requests.getOptions(inputValue,callback)
                            }}
                            onInputChange={(selectedValue, {action})=>{
                                if(action !== 'menu-close' && action !== 'input-blur') {
                                    store.articles.clearSearchElement()
                                    store.articles.setSearchInput(selectedValue)
                                }
                            }}
                            onChange={(selectedValue) => {
                                store.articles.setSearchElement(selectedValue)
                                requests.getResultsById(store.articles.searchElement.value)
                                    .then((element)=>store.articles.setResultObject(element))
                            }}
                            clearInputState={()=>store.articles.setSearchInput('')}
                        />
            }
            {((!!store.articles.searchElement && isArticleNew) || !isArticleNew) &&
                <>

                                <ArticleCard
                                    onChangeFile={(...e)=>requests.updateArticles(e)}
                                    onDeleteFile={(id)=> {
                                        !isNaN(store.articles.resultObject?.id) && requests.deleteArticleFile(id,store.articles.resultObject?.id)
                                    }}
                                    updateResultObject={(value,name)=>store.articles.updateResultObject(value,name)}
                                    value={toJS(store.articles.resultObject) ?? null}
                                    showCardNotFound={isArticleNew ? !store.articles.searchElement : !store.articles.resultObject }
                                    onDeleteArticle={()=>requests.deleteArticleById(store.articles.resultObject?.id ?? Number(articleId)).then(()=>history.push(`/strats/${stratId}/portfolios/${portfolioId}/projs/${projId}/report/articles`))}
                                    can={can}
                                    userCtx={userCtx}
                                    stratId={stratId}
                                />

                    <ButtonsCardContainer>
                                        <Button variant={'outline-secondary'} onClick={()=>history.goBack()}>Отменить</Button>
                                        {can.Edit && <Button variant={'outline-primary'}
                                                 onClick={() => requests.saveArticle(store.articles.resultObject)}>Сохранить</Button>}
                                        {can.Delete &&  <Button variant={'outline-danger'} onClick={()=>setConfirmModalOpen(!confirmModalOpen)}>Удалить</Button>}
                                        {can.Send && <Button variant={'primary'} onClick={async () => requests.sendArticle(Number(store.articles.resultObject.id))}>Отправить на согласование</Button>}
                    </ButtonsCardContainer>
                        {store.articles.resultObject?.id && <ConfirmModal show={confirmModalOpen}
                                                      headerText={'Подтверждение операции'}
                                                      onConfirm={()=>requests.deleteArticleById(store.articles.resultObject?.id ?? Number(articleId)).then(()=>history.goBack())}
                                                      onClose={()=>setConfirmModalOpen(!confirmModalOpen)}
                                                      message={'Данная статья будет удалена. Вы уверены?'}/>}
                </>
            }

        </InnerPageComponent>
    );
});

export default ArticleForm;
